import { BehaviorSubject } from "rxjs";

export const RELATIVE_PATH$ = new BehaviorSubject<string>('/')